export default __webpack_public_path__ + "static/media/pak5.fe1164de.jpg";